<jw-modal id="createArticRoute">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class="form-row">
    <div class="form-group col">
      <label>Route Name</label>
      <input
        type="text"
        [(ngModel)]='this.newRoute.name'
        [class.is-invalid]='!this.newRoute.name'
        class="form-control"
        >
    </div>
    <div class="form-group col">
      <label>Driver Start Time</label>
      <input
        type="time"
        [(ngModel)]='this.newRoute.driverStartTime'
        [class.is-invalid]='!this.newRoute.driverStartTime'
        class="form-control"
        >
    </div>
  </div>

  <button class='btn btn-success' (click)='this.save()'>Save</button>&nbsp;
  <button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
</jw-modal>
